import React, {useEffect} from "react";
import {setCb} from "./index";
import toast from 'react-hot-toast'


const ToastContainer = () => {
	useEffect(()=>{
		setCb((message,type)=>{
			if(type){
				toast.success(message,{
					position: "top-center",
					icon: '👋',
					style: {
						borderRadius: '10px',
						padding:'12px 24px',
						color: '#222',
					},
				})
			}else{
				toast.error(message,{
					position: "top-center",
					style: {
						borderRadius: '10px',
						background: '#333',
						padding:'12px 24px',
						color: '#fff',
					},
				})
			}
		})
		return () => {
			setCb(undefined)
		}
	},[])
	return(
		<div/>
	)

}

export {
	ToastContainer
}
